// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__ThZW4","input":"Input_input__+xIWo","textarea":"Input_textarea__Qbg2l","label":"Input_label__Li2pp","error-field":"Input_error-field__wtsva"};